import { Directive, ElementRef, Inject, OnInit, OnDestroy, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: 'form' // TODO: adjust this to be something specific to reactive angular forms
})
export class FormSubmitDirective {

    constructor(private host: ElementRef<HTMLFormElement>) { }

    submit$ = fromEvent(this.element, 'submit').pipe(shareReplay(1));

    get element() {
        return this.host.nativeElement;
    }
}
